import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { FeedbackAPI } from '../api';
import { useToast } from '../hooks/use-toast';

export default function FeedbackDialog({ open, onOpenChange }) {
  const [category, setCategory] = useState('general');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const { toast } = useToast();

  const submit = async () => {
    if (!message.trim()) { toast({ title: 'Add a short message' }); return; }
    setBusy(true);
    try {
      await FeedbackAPI.submit({ category, message: message.trim() });
      toast({ title: 'Thanks for the feedback', description: "Rob will read this personally." });
      setMessage('');
      onOpenChange(false);
    } catch (e) {
      toast({ title: 'Could not send  try again' });
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white text-slate-900 border-slate-200">
        <DialogHeader><DialogTitle>How's ShiftNotes going for you?</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">Tell Rob what's working, what's broken, or what you wish existed.</p>
        <div className="space-y-3 py-2">
          <div>
            <Label className="text-sm text-slate-700">Type</Label>
            <Select value={category} onValueChange={setCategory}>
              <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="general">General feedback</SelectItem>
                <SelectItem value="bug">Something is broken</SelectItem>
                <SelectItem value="feature">Feature request</SelectItem>
                <SelectItem value="kudos">Compliment / love</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-sm text-slate-700">Your message</Label>
            <Textarea value={message} onChange={e => setMessage(e.target.value)} rows={4}
              placeholder="What did you notice this week?" className="mt-1" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={submit} disabled={busy} className="bg-sky-500 hover:bg-sky-600 text-white font-semibold">
            {busy ? 'Sending...' : 'Send to Rob'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
